import {
  CustomButton,
  SearchBar,
  SwitchButton,
  searchDateFormat,
} from "components/form";
import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CustomModal, PopupModal } from "components/modals/ModalBox";
import { dateFormat, dateFormatWithTime } from "utils/dateFormat";
import Pagination from "react-js-pagination";
import useFullPageLoader from "common/UseFullPageLoader";
import useButtonLoader from "common/UseButtonLoader";
import { FaRegEdit, FaRegTrashAlt, FaRegEye } from "react-icons/fa";
import useDebounce from "common/UseDebounce";
import { toastMessage } from "utils/toastMessage";
import NotFound from "common/NotFound";
import { DatePicker } from "common/InputForm";
import { toast } from "sonner";
import { userPlaceholder } from "assets/icons";
import "./postManagement.scss";
import Select from "react-select";

import {
  productListApi,
  removeProductApi,
  updateProducttStatus,
} from "services/product";
import { masterBrandListApi, masterCategoriesListApi, masterClothingCategoriesListApi } from "services/master";
const ProductManagement = () => {
  const [deleteModal, setDeleteModal] = useState(false);
  const [productList, setProductList] = useState([]);
  const [search, setSearch] = useState("");
  const debouncedValue = useDebounce(search, 300);
  const [fieldName, setFieldName] = useState("");
  const [direaction, setDirection] = useState("");
  const [buttonLoaderFile, setButtonLoaderFile] = useButtonLoader("Export");
  const [searchParams, setSearchParams] = useSearchParams();
  const [selected, setSelected] = useState({});
  const [statusModal, setStatusModal] = useState(false);
  const [total, setTotal] = useState(null);
  const [buttonLoader, setButtonLoader] = useButtonLoader("Yes");
  const [buttonLoaders, setButtonLoaders] = useButtonLoader("Yes");
  const activePage = +searchParams.get("page") || 1;
  let searchStartDate = searchParams.get("startDate") || "";
  let searchEndDate = searchParams.get("endDate") || "";
  const limits = +searchParams.get("limit") || 10;
  const statusValue = searchParams.get("status") || "";
  const createdByValue = searchParams.get("createdBy") || "";
  const [descriptionModal, setDescriptionModal] = useState(false);
  const [description, setDescription] = useState("");
  const brandValue = searchParams.get("brand") || "";
  const categoryValue = searchParams.get("category") || "";
  const [imagePreview, setImagePreview] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [loader, onShow, onHide] = useFullPageLoader();
  const [categoryList, setCategoryList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [occasionName, setOccasionName] = useState([]);
  const occasionArray = [
    { value: "Casual", label: "Casual" },
    { value: "Formal", label: "Formal" },
    { value: "Party", label: "Party" },
  ];
  // const categoryList = [
  //   { _id: "1", name: "Tops" },
  //   { _id: "2", name: "Bottoms" },
  //   { _id: "3", name: "Dresses" },
  //   { _id: "4", name: "Shoes" },
  //   { _id: "5", name: "Accessories" },
  //   { _id: "6", name: "Jewelry" },
  //   { _id: "7", name: "Jumpsuits" },
  // ];


  const handleOccasionChange = (selectedOptions) => {
    setOccasionName(selectedOptions.map((option) => option.value));
  };
  // sort
  const toggleSortOrder = () => {
    setDirection(direaction === "ASC" ? "DESC" : "ASC");
  };
  const handleSort = (field) => {
    if (field === fieldName) {
      toggleSortOrder();
    } else {
      setFieldName(field);
      setDirection("ASC");
    }
  };
  // delete handler
  const deleteHandler = (id) => {
    setSelected({ productId: id, action: "delete" });
    setDeleteModal(true);
  };
  // change delete handler
  const changeDeleteHandler = async () => {
    try {
      setButtonLoaders(true);
      const res = await removeProductApi(selected.productId);
      if (res.data.status === 200) {
        toastMessage(res.data.message, "success", "delete");
        searchParams.delete("page");
        productListHandler();
        setDeleteModal(false);
      } else {
        toastMessage(res.data.message, "error", "delete");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoaders(false);
    }
  };

  // change student status
  const statusHandler = (id, status) => {
    setSelected({
      ...selected,
      productId: id,
      status: status === "true" ? "false" : "true",
    });
    setStatusModal(true);
  };
  /**************Change Status Handler*********************/
  const changeStatusHandler = async () => {
    try {
      setButtonLoader(true);
      const res = await updateProducttStatus(selected);
      if (res.data.status === 200) {
        toastMessage(res.data.message, "success", "changeStatus");
        setStatusModal(false);
        productListHandler();
      } else {
        toastMessage(res.data.message, "error", "changeStatus");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoader(false);
    }
  };
  // //*********start Date search********* */
  const handleStartDate = (date) => {
    searchParams.set("page", 1);
    searchParams.set("startDate", searchDateFormat(date));
    setSearchParams(searchParams);
  };
  // //*********end Date search********* */
  const handleEndDate = (date) => {
    searchParams.set("page", 1);
    searchParams.set("endDate", searchDateFormat(date));
    setSearchParams(searchParams);
  };
  /*************Reset Filter Handler*********************/
  const resetFilterHandler = () => {
    searchParams.delete("status");
    searchParams.delete("page");
    searchParams.delete("startDate");
    searchParams.delete("createdBy");
    searchParams.delete("endDate");
    searchParams.delete("brand");
    searchParams.delete("category");
    setOccasionName([])
    setSearch("");
    setSearchParams(searchParams);
  };
  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParams.set("page", event);
    setSearchParams(searchParams);
  };
  /**************Modal CLose*********************/
  const closeModal = () => {
    setStatusModal(false);
    setSelected({});
  };
  //-----------status-------------
  const handleStatus = (event) => {
    const value = event.target.value;
    searchParams.set("status", value);
    searchParams.set("page", 1);
    setSearchParams(searchParams);
  };

  const handleCategory = (event) => {
    const value = event.target.value;
    searchParams.set("category", value);
    searchParams.set("page", 1);
    setSearchParams(searchParams);
  };
  const handleBrand = (event) => {
    const value = event.target.value;
    searchParams.set("brand", value);
    searchParams.set("page", 1);
    setSearchParams(searchParams);
  };
  // student list handler
  const productListHandler = async (
    page = activePage,
    limit = limits,
    search = debouncedValue,
    sortField = fieldName || "",
    sortDirection = direaction,
    startDate = searchStartDate,
    endDate = searchEndDate,
    status = statusValue,
    addedBy = "admin",
    brand = brandValue,
    category = categoryValue,
    occasion = occasionName
  ) => {
    try {
      onShow();
      const res = await productListApi({
        page,
        search,
        limit,
        sortField,
        sortDirection,
        startDate,
        endDate,
        status,
        addedBy,
        brand,
        category,
        occasion
      });
      if (res?.status === 200) {
        setTotal(res.data.data.total);
        setProductList(res.data?.data.posts);
        onHide();
      } else {
        toastMessage(res?.data?.message, "error", "productList");
      }
    } catch (e) {
      onHide();
      toast.error(e.message);
    }
  };
  useEffect(() => {
    if (Number(activePage) === 1) {
      searchParams.delete("page");
      setSearchParams(searchParams);
    }
    productListHandler();
  }, [
    // searchParams,
    debouncedValue,
    fieldName,
    direaction,
    activePage,
    searchStartDate,
    searchEndDate,
    statusValue,
    brandValue,
    categoryValue,
    createdByValue,
    occasionName
  ]);
  useEffect(() => {
    if (search) {
      searchParams.delete("page");
    }
  }, []);
  const categoryListHandler = async () => {
    try {
      const res = await masterClothingCategoriesListApi();

      if (res?.data?.status === 200) {
        setCategoryList(res.data?.data?.categories);
      } else {
        toastMessage(res?.data?.message, "error", "categoryList");
      }
    } catch (e) {
      toastMessage(e.message, "error", "categoryList");
    }
  };
  const brandListHandler = async () => {
    try {
      const res = await masterBrandListApi();
      if (res?.data?.status === 200) {
        setBrandList(res.data?.data?.brands);
      } else {
        toastMessage(res?.data?.message, "error", "brand");
      }
    } catch (e) {
      toastMessage(e.message, "error", "brand");
    }
  };
  useEffect(() => {
    categoryListHandler();
    brandListHandler();
  }, []);
  return (
    <>
      <div className="student_management">
        <div className="card top_card">
          <div className="dashboard_title has_child">
            <h3>Exclusive Products</h3>
            <div className="d-flex">
              <Link
                to="/product-management/exclusive/add"
                className="MuiButtonBase-root MuiButton-root MuiButton-contained button"
              >
                Add Product
              </Link>
            </div>
          </div>
          <div className="button_section_wrap">
            <div className="search_wrapper">
              <SearchBar
                placeholder={"Search..."}
                onChange={(e) => {
                  setSearch(e.target.value);
                  searchParams.delete("page");
                  setSearchParams(searchParams);
                }}
                value={search}
              />
              <div className="d-flex align-items-center">
                <select
                  className="input form-control"
                  value={statusValue}
                  onChange={handleStatus}
                >
                  <option value={""}>Select Status</option>
                  <option value="true">Active</option>
                  <option value="false">In Active</option>
                </select>
                <select
                  className="input form-control"
                  type="text"
                  value={brandValue || ""}
                  name="brand"
                  onChange={handleBrand}
                >
                  <option value={""}> Select Brand</option>
                  {brandList.map((data) => (
                    <option key={data._id} value={data._id}>
                      {data.name}
                    </option>
                  ))}
                </select>
                <select
                  className="input form-control"
                  type="text"
                  value={categoryValue || ""}
                  name="category"
                  onChange={handleCategory}
                >
                  <option value={""}>Select Category</option>
                  {categoryList.map((data) => (
                    <option key={data._id} value={data.name}>
                      {data.name}
                    </option>
                  ))}
                </select>
                <Select
                  placeholder={<div>Select Occasion</div>}
                  className="multi-select"
                  isMulti
                  options={occasionArray}
                  value={occasionArray.filter((occasion) =>
                    occasionName.includes(occasion.value)
                  )}
                  onChange={handleOccasionChange}
                />

              </div>
            </div>
            <div className="button_section ">
              <DatePicker
                name="startDate"
                selected={searchStartDate}
                placeholder="Start Date"
                onChange={(date) => handleStartDate(date)}
                maxDate={searchEndDate}
              />
              <DatePicker
                name="endDate"
                placeholder="End Date"
                selected={searchEndDate}
                onChange={(date) => handleEndDate(date)}
                minDate={searchStartDate}
              />
              <CustomButton onClick={resetFilterHandler} className={"mx-2"}>
                Reset
              </CustomButton>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="table_wrap ">
              <table className="table custom_table">
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th className="nowrap">Product Code</th>
                    <th>Image</th>
                    <th
                      className="nowrap cursor-pointer"
                      onClick={() => handleSort("title")}
                    >
                      Product Title
                      <span className="shorting">
                        {fieldName === "title"
                          ? direaction === "ASC"
                            ? "↑"
                            : "↓"
                          : "↓"}
                      </span>
                    </th>
                    <th className="nowrap">Category</th>
                    <th>Brand </th>
                    <th className="nowrap">Price</th>
                    <th className="nowrap">Status</th>
                    <th className="nowrap text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loader}
                  {productList && productList?.length > 0 ? (
                    productList?.map((data, index) => {
                      console.log(data, "datvva");
                      return (
                        <tr key={++index}>
                        <td >{++index + (activePage - 1) * 10}</td>
                          <td className="nowrap">{data?.productCode || "N/A"}</td>
                          <td className="nowrap">
                            {data.images && data.images.length > 0 && (
                              <button
                                type="button"
                                onClick={() => {
                                  setImagePreview(true);
                                  setImageUrl(data.images[0]?.url);
                                }}
                              >
                                <img
                                  src={
                                    data.images[0]?.url
                                      ? data.images[0].url
                                      : userPlaceholder
                                  }
                                  className="poster"
                                  alt=""
                                />
                              </button>
                            )}
                          </td>
                          <td>{data?.title}</td>
                          <td className="nowrap">{data?.category}</td>
                          <td className="nowrap">{data?.brand?.name}</td>
                          <td className="nowrap">₹{data?.price}</td>
                          <td className="text-center">
                            {" "}
                            <Link
                              className="icon_button"
                              to=""
                              onClick={(e) => {
                                e.preventDefault();
                                statusHandler(
                                  data._id,
                                  data?.status.toString()
                                );
                              }}
                            >
                              <SwitchButton status={data?.status.toString()} />
                            </Link>
                          </td>

                          <td className="text-center">
                            <div className="icon_wrap">
                              <Link
                                to={`/product-management/exclusive/detail/${data?._id}`}
                                className="icon_button"
                              >
                                <FaRegEye />
                              </Link>

                              <Link
                                className="icon_button"
                                to={`/product-management/exclusive/edit/${data?._id}`}
                              >
                                <FaRegEdit />
                              </Link>
                              <Link
                                className="icon_button"
                                to=""
                                onClick={(e) => {
                                  e.preventDefault();
                                  deleteHandler(data?._id);
                                }}
                              >
                                <FaRegTrashAlt />
                              </Link>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <NotFound
                      cols={7}
                      msg={" Exclusive Product data not found"}
                      onHide={onHide}
                    />
                  )}
                </tbody>
              </table>
            </div>
            {total > limits && (
              <div className="pagination-wrapper">
                <div className="Pagination">
                  <Pagination
                    activePage={activePage}
                    previousLabel={"previous"}
                    nextLabel={"next"}
                    itemsCountPerPage={limits}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    hideDisabled={true}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Delete Product Modal */}
      <PopupModal
        show={deleteModal}
        handleClose={() => {
          setSelected({});
          setDeleteModal(false);
        }}
        content="Are you sure you want to delete this Product?"
        title="Delete Product"
        onShow={changeDeleteHandler}
        buttonLoader={buttonLoaders}
      />
      <PopupModal
        show={statusModal}
        handleClose={closeModal}
        content="Are you sure you want to change status of this Product?"
        title="Change Product"
        onShow={changeStatusHandler}
        buttonLoader={buttonLoader}
      />
      <CustomModal
        className={"image_preview_modal"}
        show={imagePreview}
        handleClose={() => setImagePreview(false)}
      >
        <div className="image_preview">
          <img src={imageUrl ? imageUrl : userPlaceholder} alt="" />
        </div>
      </CustomModal>

      {descriptionModal && (
        <CustomModal
          className={"add_model"}
          show={descriptionModal}
          handleClose={() => {
            setDescriptionModal(false);
          }}
        >
          <h3>Description</h3>
          <h7>{description}</h7>
        </CustomModal>
      )}
    </>
  );
};

export default ProductManagement;
